module.exports = "/images/vendor/flag-icon-css/flags/4x3/bw.svg?d1585fdf351c0bcd56a04ab460d51b3c";